export default __webpack_public_path__ + "static/media/1054.ad86f3e8.png";